// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__D0mLZ","name":"Header_name__e-ALN","birthday":"Header_birthday__1pMXt","skeleton":"Header_skeleton__3ueYX"};